import { render, staticRenderFns } from "./OpenAnswerOption.vue?vue&type=template&id=533a6792&scoped=true"
import script from "./OpenAnswerOption.vue?vue&type=script&lang=js"
export * from "./OpenAnswerOption.vue?vue&type=script&lang=js"
import style0 from "./OpenAnswerOption.vue?vue&type=style&index=0&id=533a6792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533a6792",
  null
  
)

export default component.exports